import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
import { Check, Clock, Users, Award, MapPin, Phone } from 'lucide-react';
export function HomeschoolPage() {
  useEffect(() => {
    document.title = "Homeschool Program | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  return <div className="bg-black min-h-screen" data-id="element-1264">
      <Navigation data-id="element-1265" />

      {/* Hero Section */}
      <div className="relative pt-32 pb-20 overflow-hidden" data-id="element-1266">
        <div className="absolute inset-0 z-0" data-id="element-1267">
          <img src="https://cdn.magicpatterns.com/uploads/oCqG9qZiHQwFWxB5r4xcqn/homeschool_upscale.png" alt="Homeschool Martial Arts Program" className="w-full h-full object-cover object-top opacity-30" data-id="element-1268" />
          <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black" data-id="element-1269" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1270">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-1271">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00D4FF]/10 border border-[#00D4FF]/30 text-[#00D4FF] text-sm font-semibold mb-6" data-id="element-1272">
              <span className="w-2 h-2 rounded-full bg-[#00D4FF] animate-pulse" data-id="element-1273" />
              Now Enrolling
            </div>
            <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-1274">
              <span className="text-[#00D4FF]" data-id="element-1275">Homeschool</span> Martial Arts
              Program
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-1276">
              A great way for kids ages 6 & up to stay active, build confidence,
              and learn real self-defense in a positive, structured environment.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Key Features */}
      <section className="py-20 bg-[#0a0a0a]" data-id="element-1277">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1278">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-1279">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800 text-center" data-id="element-1280">
              <Users className="w-12 h-12 text-[#00D4FF] mx-auto mb-4" data-id="element-1281" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-1282">
                Small Group Instruction
              </h3>
              <p className="text-gray-400" data-id="element-1283">
                Personalized attention in a supportive group setting
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800 text-center" data-id="element-1284">
              <Award className="w-12 h-12 text-[#00D4FF] mx-auto mb-4" data-id="element-1285" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-1286">
                Confidence • Community • Connection
              </h3>
              <p className="text-gray-400" data-id="element-1287">
                Build lasting friendships and self-assurance
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800 text-center" data-id="element-1288">
              <Clock className="w-12 h-12 text-[#00D4FF] mx-auto mb-4" data-id="element-1289" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-1290">
                Convenient Schedule
              </h3>
              <p className="text-gray-400" data-id="element-1291">
                Tuesdays & Thursdays, 11:00–11:55 AM
              </p>
            </motion.div>
          </div>

          {/* Class Schedule */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-r from-[#00D4FF]/10 to-transparent p-8 rounded-2xl border border-[#00D4FF]/20 mb-12" data-id="element-1292">
            <div className="flex items-center gap-3 mb-4" data-id="element-1293">
              <Clock className="w-6 h-6 text-[#00D4FF]" data-id="element-1294" />
              <h3 className="text-2xl font-bold text-white" data-id="element-1295">Class Schedule</h3>
            </div>
            <p className="text-xl text-gray-300 mb-2" data-id="element-1296">
              <span className="text-[#00D4FF] font-bold" data-id="element-1297">
                Tuesdays & Thursdays
              </span>
            </p>
            <p className="text-2xl text-white font-bold" data-id="element-1298">11:00 AM – 11:55 AM</p>
          </motion.div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 bg-black" data-id="element-1299">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1300">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1301">
            What Your Child Will Gain
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-1302">
            {['Stay fit and learn self-defense', 'Build confidence and self-esteem', 'Develop discipline and focus', 'Connect with other homeschool families', 'Learn from experienced instructors', 'Progress through belt ranks'].map((benefit, index) => <motion.div key={benefit} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-3" data-id="element-1303">
                <Check className="w-5 h-5 text-[#00D4FF] shrink-0 mt-1" data-id="element-1304" />
                <p className="text-gray-300 text-lg" data-id="element-1305">{benefit}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 bg-[#0a0a0a]" data-id="element-1306">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1307">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-1308">
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1309">
              Family-Owned & Locally Trusted
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed mb-8" data-id="element-1310">
              Come train with a school that's been helping kids and families
              grow—on and off the mat—for over 25 years. Proudly serving McLean
              County since 1999.
            </p>
            <div className="inline-block bg-[#1a1a1a] p-6 rounded-2xl border border-gray-800" data-id="element-1311">
              <p className="text-2xl font-bold text-[#00D4FF] mb-2" data-id="element-1312">
                Where Families Kick Together
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-20 bg-black" data-id="element-1313">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1314">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1315">
            Visit Us Today
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1316">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-1317">
              <MapPin className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-1318" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-1319">Location</h3>
              <p className="text-gray-300" data-id="element-1320">1304 E. Empire St.</p>
              <p className="text-gray-300" data-id="element-1321">Bloomington, IL</p>
              <p className="text-gray-400 text-sm mt-2" data-id="element-1322">
                Across from Towanda Plaza
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-1323">
              <Phone className="w-8 h-8 text-[#00D4FF] mb-4" data-id="element-1324" />
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-1325">Contact</h3>
              <a href="tel:309-242-4440" className="text-gray-300 hover:text-[#00D4FF] transition-colors text-lg" data-id="element-1326">
                309-242-4440
              </a>
              <p className="text-gray-400 text-sm mt-2" data-id="element-1327">
                Call to learn more or schedule a visit
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <CTASection data-id="element-1328" />
      <Footer data-id="element-1329" />
    </div>;
}